import { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import { PageTitle } from "../../../shared/ui/common";
import MultiSafepaySettings from "./MultiSafepaySettings";
import ZarinpalSettings from "./ZarinpalSettings";

/** Independent settings tabs; the backend enforces a single active gateway. */
export default function PaymentGatewaySettings() {
  const [gateway, setGateway] = useState("multisafepay");
  return <>
    <PageTitle title="تنظیمات درگاه پرداخت" broadCrumb={[{ title: "تنظیمات", path: "/payment-gateway" }]} />
    <Tabs value={gateway} onChange={(_, value) => setGateway(value)} aria-label="درگاه‌های پرداخت" className="md:mx-3 mx-1 mb-3">
      <Tab value="multisafepay" label="MultiSafepay" id="gateway-tab-multisafepay" aria-controls="gateway-panel-multisafepay" />
      <Tab value="zarinpal" label="زرین‌پال" id="gateway-tab-zarinpal" aria-controls="gateway-panel-zarinpal" />
    </Tabs>
    <div role="tabpanel" id={`gateway-panel-${gateway}`} aria-labelledby={`gateway-tab-${gateway}`}>
      {gateway === "multisafepay" ? <MultiSafepaySettings /> : <ZarinpalSettings />}
    </div>
  </>;
}
